// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

// Helpers
import classNames from 'classnames';
import { getBodyTypesText } from 'Common/formValues';
import { gtmEventPush } from 'utils/gtm/events';

// Components
import Icon from 'Common/Icon';

// Styles
import bootstrap from 'vendor/bootstrap/_bootstrap_custom.scss';
import styles from 'components/CarType.scss';

/**
 * <CarType /> component.
 */
class CarType extends Component<*, *> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   * @prop {string} name - car type.
   * @prop {string} size - icon size
   * @prop {string} label - icon label.
   * @prop {string} results - car type results
   * @prop {string} selectedValue - selectedValue
   * @prop {bool} isSelected - selected state
   * @prop {string} value - value
   * @prop {boolean} isResults - isResults
   */
  static propTypes = {
    name: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    results: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedValue: PropTypes.string,
    value: PropTypes.string,
    isResults: PropTypes.bool,
    isDisabled: PropTypes.bool
  };

  /**
   * Renders <Image /> component.
   *
   * @return {JSX} - renders a logo.
   */
  render() {
    const {
      name,
      size,
      label,
      results,
      selectedValue,
      value,
      isResults,
      isDisabled
    } = this.props;

    return (
      <div
        className={classNames(
          styles.carType,
          isResults ? styles.carTypeResults : null
        )}
      >
        <label
          className={classNames(
            selectedValue && selectedValue === value ? styles.selected : null,
            results === 0 ? styles.disabled : null
          )}
        >
          <Field
            name={name}
            component={props => (
              <input
                type="radio"
                className={bootstrap.srOnly}
                selected={selectedValue === value}
                value={value}
                disabled={results === 0 || isDisabled}
                onChange={event => {
                  // Nasty, but I think this has to be here,
                  gtmEventPush({
                    method: 'filterForm',
                    args: {
                      itemLabel: 'Category'
                    }
                  });
                  props.input.onChange(selectedValue === value ? '' : event);
                }}
              />
            )}
          />
          <div>
            <Icon iconName={label} size={size} />
            <span className={styles.label}>{getBodyTypesText(label)}</span>
            <span className={styles.results}>{results}</span>
          </div>
        </label>
      </div>
    );
  }
}

export default CarType;



// WEBPACK FOOTER //
// ./src/Common/CarType/index.js